/**
 * Sistema de logging condicional
 * Solo muestra logs en modo desarrollo
 */

const isDev = import.meta.env.DEV || import.meta.env.VITE_DEBUG === 'true'

// Crear logger con colores y prefijos
export const logger = {
  // Logs generales (solo en desarrollo)
  log: (...args) => {
    if (isDev) console.log('🔍', ...args)
  },
  
  // Errores (siempre se muestran)
  error: (...args) => {
    console.error('❌', ...args)
  },
  
  // Warnings (siempre se muestran)
  warn: (...args) => {
    console.warn('⚠️', ...args)
  },
  
  // Debug específico (solo en desarrollo)
  debug: (...args) => {
    if (isDev) console.debug('🐛', ...args)
  },
  
  // Información (solo en desarrollo)
  info: (...args) => {
    if (isDev) console.info('ℹ️', ...args)
  },
  
  // Auth específico
  auth: (...args) => {
    if (isDev) console.log('🔐', ...args)
  },
  
  // API calls
  api: (...args) => {
    if (isDev) console.log('🌐', ...args)
  },
  
  // Navigation
  nav: (...args) => {
    if (isDev) console.log('🚀', ...args)
  }
}

// Helper para medir performance
export const measurePerformance = (name, fn) => {
  if (!isDev) return fn()
  
  const start = performance.now()
  const result = fn()
  const end = performance.now()
  logger.debug(`⏱️ ${name} took ${(end - start).toFixed(2)}ms`)
  return result
}

// Helper para logs grupados
export const logGroup = (title, fn) => {
  if (!isDev) return fn()
  
  console.group(`📁 ${title}`)
  const result = fn()
  console.groupEnd()
  return result
}

export default logger